const toggle = {
  isEmpty: true,
  bind: function(el, { modifiers }, vnode) {
    let key = Object.keys(modifiers)[0];
    if (key) {
      vnode.context.$set(vnode.context.toggle, key, el.checked);
      el.addEventListener("change", function() {
        vnode.context.$set(vnode.context.toggle, key, el.checked);
      });
    }
  },
};

export default { toggle };
